// src/components/CommentForm.js
import React, { useState } from 'react';
import { addComment } from '../firebase/comments';

const CommentForm = ({ user, onError }) => {
  const [text, setText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    
    setIsSubmitting(true);
    setSuccessMessage('');
    
    try {
      const newComment = {
        author: user.displayName,
        authorId: user.uid,
        authorPhoto: user.photoURL,
        text,
        type: 'comment',
        course: 'exam-content',
        platform: 'cosknow'
      };
      
      await addComment(newComment);
      
      // Reset form
      setText('');
      
      // Show success message
      setSuccessMessage('Comment posted successfully!');
      
      // Clear success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
      
    } catch (err) {
      onError('Failed to submit comment. Please try again.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="form-container">
      <h3>Add a Comment</h3>
      
      {successMessage && (
        <div className="success-message">{successMessage}</div>
      )}
      
      <div className="form-group">
        <label htmlFor="comment-text">Comment:</label>
        <textarea
          id="comment-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Share your thoughts about the exam content..."
          rows="4"
          required
          disabled={isSubmitting}
        />
      </div>
      <button 
        type="submit" 
        className="submit-button"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Posting...' : 'Post Comment'}
      </button>
    </form>
  );
};

export default CommentForm;